import * as React from 'react';
import { RegularButton } from 'fronton-react';
import { ThumbsDownIcon, ThumbsUpIcon } from '@fronton/icons-react';

export type LikeDislikeButtonProps = {
  value: number;
  type: 'LIKE' | 'DISLIKE';
  selected: boolean;
  onClick: () => void;
};

export const LikeDislikeButton: React.FC<LikeDislikeButtonProps> = ({ type, onClick, value, selected }) => {
  const haveToShowLabel = value > 0;
  return (
    <RegularButton
      iconLeft={type === 'LIKE' ? <ThumbsUpIcon /> : <ThumbsDownIcon />}
      variant={selected ? 'primary' : 'outline'}
      data-testid={`${type.toLowerCase()}-btn_pdp`}
      onClick={onClick}
      size="m"
      rounded
      aria-hidden={haveToShowLabel ? 'false' : 'true'}
    >
      {haveToShowLabel && <>{value}</>}
    </RegularButton>
  );
};
